import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import { connect } from 'react-redux';
import { graphql, useFragment } from 'react-relay';
import { isOnProjectPane } from '../../reducers/checkoutPaneReducer';

// components
import CheckoutSidebarPane from '../CheckoutSidebarPane';
import CheckoutSidebarProjectForm from './CheckoutSidebarProjectForm';

const title = (
    <FormattedMessage
        id="checkout.CheckoutSidebarProjectPane.title"
        defaultMessage="Project (Optional)"
    />
);

const CheckoutSidebarProjectPane = props => {
    const { viewer: viewerRef, buyer: buyerRef, isOnProject, onClick } = props;

    const viewer = useFragment(
        graphql`
            fragment CheckoutSidebarProjectPane_viewer on Viewer {
                ...CheckoutSidebarProjectForm_viewer
            }
        `,
        viewerRef
    );

    const buyer = useFragment(
        graphql`
            fragment CheckoutSidebarProjectPane_buyer on User {
                ...CheckoutSidebarProjectForm_buyer
            }
        `,
        buyerRef
    );

    return (
        <CheckoutSidebarPane
            title={title}
            isClickable
            dataTn={'checkout-project-pane'}
            onClick={onClick}
            isExpanded={isOnProject}
        >
            <CheckoutSidebarProjectForm viewer={viewer} buyer={buyer} />
        </CheckoutSidebarPane>
    );
};

CheckoutSidebarProjectPane.propTypes = {
    viewer: PropTypes.object.isRequired,
    buyer: PropTypes.object.isRequired,
    isOnProject: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default connect(({ pane }) => ({
    isOnProject: isOnProjectPane(pane),
}))(CheckoutSidebarProjectPane);
